import React, { useState, useEffect } from "react"
import _ from "lodash"

import { NumberInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { InputText_s } from "styles/input-styles"
import { MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const RoomsAreaDetailed = (props: {rowData: [], defaults: object, field: string, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyRecord = {
    occup: null
  }

  const [data, setData] = useState<object|null>(props.rowData[props.field])
  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }}), "date") : [{...emptyRecord, i: 0}]);

  function updateVal(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data || {})
    if(items[field[0]][field[1]] === val) return
    items[field[0]][field[1]] = val
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => ({...rest, year: i+1})))
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'detailedYr') _.set(newData, 'state', 'detailedYr')
    setData(newData)
    props.persist({items: newData.items, dateMode: 'relative', state: 'detailedYr'}, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let newData = _.cloneDeep(data);
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest));
    _.set(newData, 'items', strippedItems);
    if (newData.state !== 'detailedYr') _.set(newData, 'state', 'detailedYr');
    props.persist({items: strippedItems.map((item, i) => { return {...item, year: i + 1}}), dateMode: newData.dateMode, state: 'detailedYr'}, 'occupancydetail', props.rowData);
  }

  let renderItems = _.sortBy(items, 'i');

  useEffect(() => {
    if (props['rowData']['occupancydetail']?.state !== 'detailedYr'){
      setItems([{...emptyRecord, i: 0}]);
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('room', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div>
              { i === 0 && <label>Year</label> }
              <InputText_s readOnly value={i+1} className="year-input" />
            </div>
            <div>
              { i === 0 && <label>Amt</label> }
              <NumberInput 
                attrs={attrs}
                className="automated"  
                data={items}
                field={[`${row['i']}`, 'occup']}
                min={0} 
                persist={updateVal}
                readPrecision={4} 
                writePrecision={4} 
              />
            </div>  
            <RowAddRemove emptyRecord={{occup: null, i}} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default RoomsAreaDetailed
